// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__H3i96","buttonContainer":"styles_buttonContainer__MCk6r"};